/* SLIDE 14 */
/* SLIDE 15 */


import cameraIcon from "assets/icons/cameraIcon.svg";
import captureClose from "assets/icons/captureClose.svg";
import captureIcon from "assets/icons/captureIcon.svg";
import cardIcon from "assets/icons/cardIcon.svg";
import checkIcon from "assets/icons/checkIcon.svg";
import removeDiscountIcon from "assets/icons/removeDiscountIcon.svg";
import { applyOrCancelDiscountUnpaid, checkFee, checkParkingEntry, checkParkingEntryDiscount, getDiscountList, onPaymentFee, uploadDiscountImage } from "features/parking/usecases/CarInOutUsecases";
import React, { useEffect, useReducer, useRef, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AppInfoRow from "shared/components/AppInfoRow";
import AppSelect from "shared/components/AppSelect";
import ButtonBot from "shared/components/ButtonBot";
import Popup from "shared/components/Popup";
import SubHeader from "shared/components/SubHeader";
import { setShowHeader } from "shared/store/headerSlice";
import { makeCenterLine, makeFixedLine, numberFormat, maskCardNumber, formatMinutesToTime } from "utils/common";
import { setAppLoading, setShowBack } from "../../../shared/store/headerSlice";
import { datetimeFormat, getFormattedTime, replaceImageLink } from "../../../utils/common";
import { setSelectedUnpaid } from "./store/parkingSlice";
import { DateTime } from "luxon";
import { carImageSub, getParkingTid } from "../usecases/CarInOutUsecases";
import { onGetParkingTid } from "../utils/parkingUtils";
import { captureImage, handleImageError, startCamera, stopCamera } from "../utils/cameraUtils";
import { getApiBaseUrl } from "../../../helpers/api";
import ImageViewPopup from "../../../shared/components/ImageViewPopup";

// Manage State popup with usereducer
const initialPopupState = {
  showPopupDiscount: false,
  showPopupPay: false,
  showPopupPayError: false,
  showPopupError: false,
  showPopupErrorTime: false,
  showPopupCompareTime: false,
  showPopupNice: false,
  showPopupRemoveDiscount: false,
  showPopupFeeAlert: false,
  showPopupMissingTid: false,
  showPopupFreeFee: false,
  showPopupZeroFee: false,
};

const popupReducer = (state, action) => {
  switch (action.type) {
    case 'SET_POPUP':
      return { ...state, [action.payload.key]: action.payload.value };
    case 'RESET':
      return initialPopupState;
    default:
      return state;
  }
};


function ParkingUnpaidDetail() {
  const [popupState, dispatchPopup] = useReducer(popupReducer, initialPopupState);

  const [showPopup, setShowPopup] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [completePayment, setCompletePayment] = useState(false);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [pageLoading, setPageLoading] = useState(1);
  const [selectedDiscount, setSelectedDiscount] = useState("");
  const [selectedDiscountRemove, setSelectedDiscountRemove] = useState("");
  const [selectedDiscountApplyTime, setSelectedDiscountApplyTime] = useState("");
  const [discountList, setDiscountList] = useState([]);
  const [discountImage, setDiscountImage] = useState(null);
  const [discountImageRemove, setDiscountImageRemove] = useState(null);
  const [isOpenCamera, setIsOpenCamera] = useState(false);
  const [parkingTid, setParkingTid] = useState(null);
  const [payData, setPayData] = useState({});
  const [showErrorImg, setShowErrorImg] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [isPopupFullCustomImageOpen, setIsPopupCustomImageFullOpen] = useState(false);
  const [customImage, setCustomImage] = useState({
    image1: null,
    image2: null
  })

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const discountRef = useRef(null);
  const customImageOrderRef = useRef(1);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { selectedUnpaid, parkingName } = useSelector((state) => state.parking);
  const { user, serverTime } = useSelector((state) => state.auth);

  console.log("Selected Unpaid:", selectedUnpaid);

  useEffect(() => {
    if (completePayment) {
      dispatch(setShowBack(false));
    }
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach(track => track.stop());
      }
    };
  }, [completePayment]);

  useEffect(() => {
    if (discountImage) {
      setShowErrorImg(false);
    }
  }, [discountImage]);

  const fetchCarImageSub = async () => {
    try {
      const response = await carImageSub({
        parkingId: user.parkingId,
        entryId: selectedUnpaid?.parkingEntry?.localEntryId
      });
      response?.carImageList?.map((value, index) => {
        if (value?.carImage?.includes("_1.")) {
          setCustomImage(prev => {
            return {
              ...prev,
              image1: replaceImageLink(value?.carImage),
              imageOrigin1: value?.carImage
            }
          })
        } else {
          setCustomImage(prev => {
            return {
              ...prev,
              image2: replaceImageLink(value?.carImage),
              imageOrigin2: value?.carImage
            }
          })
        }
      })


    } catch (error) {
      console.error("Error fetching discount list:", error);
    }

  }

  const fetchCheckOutFee = async () => {
    pageLoading > 1 && dispatch(setAppLoading(true));

    try {
      await fetchDiscountList();
      const response = await checkFee({
        parkingId: user.parkingId,
        carNumber: selectedUnpaid?.parkingEntry.carNum,
        facilityId: "00003",
      });
      if (response?.fee?.discountDetails?.length > 0) {
        let discountDetails = response?.fee?.discountDetails?.map((item) => ({
          discountId: item.id,
          name: item.name,
          fee: item.fee,
        }));
        dispatch(setSelectedUnpaid({
          ...selectedUnpaid,
          discountAmount: response?.fee?.feeDiscount || 0,
          discountDetails: discountDetails || [],
          feeCalculated: response?.fee?.feeCalculated || 0,
          feeFinal: response?.fee?.feeFinal || 0,
          feeDiscount: response?.fee?.feeDiscount || 0,
        }))
        setSelectedDiscount(response?.fee?.discountDetails?.[0]?.id || "");
        setSelectedDiscountApplyTime(response?.fee?.discountDetails[0]?.applyTime || "");
        discountRef.current = response?.fee?.discountDetails?.[0]?.id || "";
      }
      let parkingEntry = {
        ...selectedUnpaid.parkingEntry,
        inTime: selectedUnpaid.parkingEntry.inTime || DateTime.fromISO(selectedUnpaid.inTime).toFormat("yyyyMMddHHmmss"),
        outTime: selectedUnpaid.parkingEntry.outTime || DateTime.fromISO(selectedUnpaid.outTime).toFormat("yyyyMMddHHmmss"),
        entryId: selectedUnpaid.parkingEntry.localEntryId,
        inImageLink: selectedUnpaid.parkingEntry.inImagePath,
        outImageLink: selectedUnpaid.parkingEntry.outImagePath,
      }
      console.log("CheckOut Fee Response:", parkingEntry);
      const checkEntry = await checkParkingEntry(parkingEntry);

      // console.log("Check Entry:", checkEntry);
      // console.log(selectedUnpaid.discountDetails, "selectedUnpaid.discountDetails")
      for (const discount of selectedUnpaid?.discountDetails || []) {
        let checkDiscount = await checkParkingEntryDiscount({
          parkingEntryId: selectedUnpaid?.parkingEntry?.parkingEntryId,
          discountId: discount?.discountId,
          discountApplyId: discount?.discountApplyId,
          discountAmount: discount?.fee,
          parkingId: selectedUnpaid.parkingId,
          applyTime: discount?.applyTime,
          localEntryId: selectedUnpaid?.parkingEntry?.localEntryId,
        });

        console.log("Check Entry:", checkDiscount);

      }
      // };
      // setCheckOutData(response);
      // setPaymentAmount(response?.fee?.feeFinal);


    } catch (error) {
      console.error("Error fetching checkout fee:", error);
    } finally {
      setPageLoading(prev => prev + 1);
      dispatch(setAppLoading(false));
    }


  };

  const fetchDiscountList = async () => {
    await new Promise(async (resolve, reject) => {
      try {
        const response = await getDiscountList({
          parkingId: user.parkingId
        });

        let discountList = response?.discountList.map((item) => ({
          label: `${item.discountName} (${item.value}${item.discountCategoryCd == "FEE" ? "원" : (item.discountCategoryCd == "PERCENTAGE" ? "%" : "분")})`,
          value: item.discountId,
          discountId: item.discountId,
          discountCategoryCd: item.discountCategoryCd,
          ranking: item.ranking,
          // discountId: item.discountId,
        }));
        discountList.unshift({
          label: "할인 옵션 선택",
          value: "",
        });
        setDiscountList(discountList);
        resolve();

      } catch (error) {
        console.error("Error fetching discount list:", error);
        reject(error);
      }
    });

  };

  useEffect(() => {
    if (isOpenCamera) startCamera({
      videoRef: videoRef,
      setShowHeader: (value) => dispatch(setShowHeader(value)),
    });
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach(track => track.stop());
      }
    };
  }, [isOpenCamera]);

  const onEnterPage = async () => {
    let parkingEntry = {
      ...selectedUnpaid.parkingEntry,
      inTime: selectedUnpaid.parkingEntry.inTime || DateTime.fromISO(selectedUnpaid.inTime).toFormat("yyyyMMddHHmmss"),
      outTime: selectedUnpaid.parkingEntry.outTime || DateTime.fromISO(selectedUnpaid.outTime).toFormat("yyyyMMddHHmmss"),
      entryId: selectedUnpaid.parkingEntry.localEntryId,
      inImageLink: selectedUnpaid.parkingEntry.inImagePath,
      outImageLink: selectedUnpaid.parkingEntry.outImagePath,
    }
    console.log("CheckOut Fee Response:", parkingEntry);
    await checkParkingEntry(parkingEntry);
    await fetchCarImageSub();
    setPageLoading(prev => prev + 1);
    dispatch(setAppLoading(false));

  }

  useEffect(() => {
    onEnterPage();

    return () => {
      setPageLoading(1);
    };
  }, []);

  const handlePaymentResponse = (event) => {
    const msg = JSON.parse(event.data);
    try {
      if (msg.type === 'payRes') {
        if (['0000', '0021'].includes(msg.body.responseCode)) {
          setPayData(msg.body);
          onPaymentSuccess(msg.body);

        } else {
          setLoadingPayment(false);
          dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPayError', value: true } });
        }
      } else if (msg.type === 'printRes') {
        if (['0000', '0021'].includes(msg.body.responseCode)) {
          // when print success
        }
      } else if (msg.type === "notInstalled") {
        dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupNice', value: true } });
        setLoadingPayment(false);
      }
    } catch (e) {
      alert("Error parsing message:", e.message);
      console.error("Fail to parse message:", e);
    }
  };

  useEffect(() => {
    // window.addEventListener('message', responseHandler);
    document.addEventListener("message", handlePaymentResponse);
    return () => document.removeEventListener("message", handlePaymentResponse);
  }, [paymentAmount, parkingTid]);

  const onReceiptPrint = async () => {
    dispatch(setAppLoading(true));
    try {
      const sampleForm = `
${makeCenterLine('[입차증]')}
================================================
${makeFixedLine('구획번호:', selectedUnpaid?.spaceNumber || "")} 
${makeFixedLine('차량번호:', selectedUnpaid?.carNumber)}
${makeFixedLine('관리자번호:', user?.mobilePhone)}
${makeFixedLine('입차시간:', datetimeFormat(selectedUnpaid?.inTime, "ISO", "yyyy-MM-dd HH:mm"))}
${makeFixedLine('출차시간:', datetimeFormat(selectedUnpaid?.outTime, "ISO", "yyyy-MM-dd HH:mm"))}
${makeFixedLine('주차장소:', user?.parking?.parkingName)}
${makeFixedLine('결제금액:', numberFormat(paymentAmount || 0, "원"))}
${makeFixedLine('거래일시:', getFormattedTime(serverTime, "yyyy-MM-dd HH:mm"))}
${makeFixedLine('사업자번호:', window.APP_CONFIG?.bizRegNo || '')}
${makeFixedLine('주차문의:', user?.parking?.phoneNumber)}
================================================
${makeCenterLine('근무자 휴식시간 안내')}
* 현장근무자 휴식시간 및 전화가 꺼져있는 경우 하단 관리자번호로 차량번호 필수 작성 후 문자 보내주세요. 주차요금 계좌번호 등 문자 전송해 드립니다.
================================================
${makeCenterLine('미납요금 납부방법')}
송파구시설관리공단 공영주차부 홈페이지 
(www.songpagongdanpark2.or.kr) 미납요금 조회 및 요금을 납부하실 수 있습니다.
================================================
${makeCenterLine('결제문의')}
주차관리자 관리자 번호 전화기가 꺼져있을경우 문자 남겨주세요.
================================================
${makeCenterLine('송파구시설관리공단')}
`;

      // print params for VAN API
      const params = new URLSearchParams({
        billType: '9',                          // 전문종류 ( 9:프린터출력 )
        terminalNo: '1004930001',               // 단말기 번호 ( 테스트 TID : 1004930001 )
        orderKey: '99999',                      // 주문번호 ( 요청/응답 명시 용도 )
        printResType: '1',
        resScheme: 'innodep://printResponse',   // 응답 스키마 ( ex. nicepos://response... )
      });

      if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "print", body: params.toString(), printForm: sampleForm })
        );
      } else {
        setLoadingPayment(false);
        console.error('Cannot find Native App !!');
      }
    } catch (error) {
      console.error('Error parsing WebView message:', error);
    } finally {
      dispatch(setAppLoading(false));
    }


  }

  const onBillPrint = async (payRes) => {

    const encoder = new TextEncoder(); // 기본 utf-8

    const form = [
      0x0A,
      0x1B, 0x40, //명령 초기화

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode(makeCenterLine('매출전표', true)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화 

      0x1B, 0x61, 0x02,   // 우측 정렬
      ...encoder.encode('No:' + (window.APP_CONFIG?.parkingSeq || '000010')), 0x0A,
      0x1B, 0x61, 0x00,   // 왼쪽 정렬

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode('-'.repeat(24)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화
      0x0A,

      ...encoder.encode(makeFixedLine('주차장명:', user?.parking?.parkingName)), 0x0A,
      ...encoder.encode(makeFixedLine('사업자주소:', user?.parking?.address)), 0x0A,
      ...encoder.encode(makeFixedLine('전화번호:', user?.parking?.phoneNumber)), 0x0A,
      ...encoder.encode(makeFixedLine('일시:', getFormattedTime(serverTime, "yyyy-MM-dd HH:mm:ss"))), 0x0A,

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode('-'.repeat(24)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화
      0x0A,

      ...encoder.encode(makeFixedLine('차량번호:', selectedUnpaid?.carNumber)), 0x0A,
      ...encoder.encode(makeFixedLine('입차일시:', datetimeFormat(selectedUnpaid?.inTime, "ISO", "yyyy-MM-dd HH:mm"))), 0x0A,
      ...encoder.encode(makeFixedLine('출차일시:', datetimeFormat(selectedUnpaid?.outTime, "ISO", "yyyy-MM-dd HH:mm"))), 0x0A,
      ...encoder.encode(makeFixedLine('주차시간:', formatMinutesToTime(selectedUnpaid?.parkingMinute))), 0x0A,
      ...encoder.encode(makeFixedLine('주차요금:', numberFormat(selectedUnpaid?.feeCalculated))), 0x0A,

    ];


    if (Array.isArray(selectedUnpaid?.discountDetails)) {
      selectedUnpaid?.discountDetails.forEach((discount, idx) => {
        form.push(
          ...encoder.encode(makeFixedLine(idx === 0 ? '할인항목:' : '', discount.name)), 0x0A,
        );
      });
    }

    form.push(
      ...encoder.encode(makeFixedLine('할인금액:', numberFormat(selectedUnpaid?.feeDiscount))), 0x0A,
      ...encoder.encode(makeFixedLine('정산금액:', numberFormat(paymentAmount))), 0x0A,

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode('-'.repeat(24)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화
      0x0A,

      ...encoder.encode(makeFixedLine('카드번호:', maskCardNumber(payRes?.track2Data))), 0x0A,
      ...encoder.encode(makeFixedLine('승인번호:', payRes?.authNo)), 0x0A,
      ...encoder.encode(makeFixedLine('카드사명:', payRes?.issuerCompany)), 0x0A,
      ...encoder.encode(makeFixedLine('매입사명:', payRes?.buyerCompany)), 0x0A,

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode('-'.repeat(24)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화
      0x0A,

      ...encoder.encode(makeCenterLine('이용해 주셔서 감사합니다.')), 0x0A
    );

    const formData = new Uint8Array(form);

    const formEnc = btoa(String.fromCharCode(...formData));

    const payKey = await onGetParkingTid(user.parkingId);

    if (!payKey || !payKey.tid) {
      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupMissingTid', value: true } });
      return;
    }

    // print params for VAN API
    const params = new URLSearchParams({
      billType: '9',                        // 전문종류 ( 9:프린터출력 )
      terminalNo: payKey?.tid,              // 단말기 번호
      orderKey: '99999',                    // 주문번호 ( 요청/응답 명시 용도 )
      printResType: '1',
      resScheme: 'innodep://printResponse', // 응답 스키마
    });

    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "print", body: params.toString(), printForm: formEnc })
      );
    } else {
      // setLoadingPayment(false);
      console.error('Cannot find Native App !!');
    }
  }


  useEffect(() => {
    setPaymentAmount(selectedUnpaid?.feeFinal);
  }, [selectedUnpaid]);

  const onFreeFee = async () => {

    dispatchPopup({ type: 'RESET' });
    setLoadingPayment(true);

    onPaymentSuccess({});
  }

  const onPaymentSuccess = async (payRes) => {
    // dispatchPopup({ type: 'RESET' });
    // setLoadingPayment(true);

    try {
      let inDate = getFormattedTime(serverTime, "ISO");
      const data = {
        parkingId: selectedUnpaid.parkingId,
        facilityId: "00003",
        facilityKind: "LPR_OUT",
        angle: "MAIN",
        recognitionId: "11",
        carNumber: selectedUnpaid.carNumber,
        dateTime: inDate,
        payStationId: "MOBILE",
        userId: user.userId,
        feeDiscount: selectedUnpaid?.feeDiscount || 0,
        feeCalculated: selectedUnpaid?.feeCalculated || 0,
        feeFinal: selectedUnpaid?.feeFinal || 0,
      };

      console.log("Payment Data:", data);
      setLoadingPayment(true);
      const payTime = DateTime.fromFormat(`20${payRes?.authDate}`, "yyMMddHHmmss");
      const price = paymentAmount || 0;
      const payment = await onPaymentFee({
        ...data,
        payWay: price == 0 ? "CASH" : "CRDCRD",
        payStationId: user.userId,
        price: paymentAmount || 0,
        payTime: payTime?.isValid ? payTime.toISO() : getFormattedTime(serverTime, "ISO"),
        entryList: [
          {
            payType: "UNPAID_FEE",
            parkingEntryId: selectedUnpaid?.parkingEntry.parkingEntryId,
            localEntryId: selectedUnpaid?.parkingEntry.localEntryId,
            membershipApplicantId: "",  // 정기권ID
            extendedMonths: 0,          // 정기권 연장 달수
          },
        ],

        cardNumber: maskCardNumber(payRes?.track2Data),
        approvalNumber: payRes?.authNo,
        buyerCode: payRes?.buyerCode,
        buyerName: payRes?.buyerCompany,
        issuerCode: payRes?.issuerCode,
        issuerName: payRes?.issuerCompany,
        storeNumber: payRes?.storeNo,
        terminalId: parkingTid || "1004930001",
        cardReadData: payRes?.payUniqueNo,
      });
      if (payment.gate == "OPEN") {
        setCompletePayment(true);
        setLoadingPayment(false);
      } else {
        setCompletePayment(true);
        setLoadingPayment(false);
      }

      onBillPrint(payRes);
    } catch (error) {
      console.error("Payment Error:", error);
      setLoadingPayment(false);
    }
  };

  const onPayment = async () => {

    if (paymentAmount <= 0) {
      dispatch(setAppLoading(true));
      await onPaymentSuccess();
      dispatch(setAppLoading(false));
      return false;
    }

    dispatchPopup({ type: 'RESET' });
    setLoadingPayment(true);
    // if (paymentAmount < selectedUnpaid?.feeFinal) {
    //   setShowPopupPay(false);
    //   setShowPopupFeeAlert(true);
    //   return;
    // }

    // setShowPopupPay(false);

    const payKey = await onGetParkingTid(user.parkingId);

    if (!payKey || !payKey.tid) {
      setLoadingPayment(false);
      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupMissingTid', value: true } });
      return;
    } else {
      setParkingTid(payKey.tid);
    }
    // payment params
    const params = new URLSearchParams({
      billType: '0',                      // 전문종류 ( 0:신용 )
      terminalNo: payKey?.tid,            // 단말기 번호
      orderKey: '99999',                  // 주문번호 ( 요청/응답 명시 용도 )
      authType: '0',                      // 0: 승인, 1: 취소
      installment: '00',                  // 할부 개월 ( 00:일시불 )
      amount: paymentAmount || '0',       // 거래금액 ( 부가세, 봉사료 제외 금액 )
      tax: '0',                           // 세금 (부가세 없음)
      tip: '0',                           // 봉사료 (없음)
      isSign: 'D',                        // 서명처리 ( ‘Y’:사용, ‘N’:미사용, ‘D’: NICEPAY 앱 판단 )
      resScheme: 'innodep://payResponse', // 응답 스키마
    });

    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "payReq", body: params.toString() })
      );
    } else {
      setLoadingPayment(false);
      // setShowPopupPay(false);

      console.error("Cannot find Native App !!");
    }

    // pay request End
  };

  const onCancelAllDiscount = async (type) => {
    dispatchPopup({ type: 'RESET' });
    dispatch(setAppLoading(true));
    try {
      for (const item of selectedUnpaid?.discountDetails || []) {
        await applyOrCancelDiscountUnpaid({
          parkingId: selectedUnpaid.parkingId,
          carNumber: selectedUnpaid?.parkingEntry.carNum,
          userId: user.userId,
          discountFlag: "CANCEL",
          discountId: item?.discountId,
          entryId: selectedUnpaid?.parkingEntry.parkingEntryId,
          localEntryId: selectedUnpaid?.parkingEntry.localEntryId,
        });

      }

      const response = await applyOrCancelDiscountUnpaid({
        parkingId: selectedUnpaid.parkingId,
        carNumber: selectedUnpaid?.parkingEntry.carNum,
        userId: user.userId,
        discountFlag: type,
        discountId: '',
        entryId: selectedUnpaid?.parkingEntry.parkingEntryId,
        localEntryId: selectedUnpaid?.parkingEntry.localEntryId,
        discountAmount: selectedUnpaid?.fee || 0,
      });

      if (response.status == 200) {
        discountRef.current = (type == "CANCEL" ? null : selectedDiscount)
        setDiscountImage(null);
        setSelectedDiscountRemove("");
        if (type == "CANCEL") {
          setSelectedDiscount("");
          setDiscountImageRemove(null)
        }
        // setSelectedDiscount("");
        let discountDetails = response?.discountDetails.map((item) => ({
          discountId: item.id,
          name: item.name,
          fee: item.fee,
        }));
        dispatch(setSelectedUnpaid({
          ...selectedUnpaid,
          ...response,
          discountDetails: discountDetails,
        }));
        setPaymentAmount(response?.feeFinal);
        // setSelectedDiscount('');
        toast.success('성공했습니다.', {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: 'htToastSuccess',
        });
      } else {
        throw new Error("Failed to apply discount");
      }

    } catch (error) {
      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupError', value: true } });
      console.error("Error during discount application:", error);
    } finally {
      dispatch(setAppLoading(false));
    }
  }

  function isIdInArray(array, idToCheck) {
    return array.some(item => item.discountId === idToCheck);
  }

  const onApplyOrCancelDiscount = async (type, id) => {
    console.log(id)
    var imageArrShow = ['12', '13', '14', '15', '18', '19', '21', '22', '23', '24', '26', '27', '29', '30']
    let multipleDiscount = ['10', '30']
    if (type == "APPLY") {
      if (imageArrShow.includes(id)) {
        if (discountImage == null) {
          setShowErrorImg(true)
          return false;
        }
      }
    }

    let currentDiscount = selectedUnpaid?.discountDetails || [];

    if (multipleDiscount.includes(id) && isIdInArray(currentDiscount, id) && type == "APPLY") {
      return false;
    }

    dispatchPopup({ type: 'RESET' });
    dispatch(setAppLoading(true));

    try {

      if (type == "APPLY" && !multipleDiscount.includes(id)) {
        for (const item of selectedUnpaid?.discountDetails || []) {

          !multipleDiscount.includes(item?.discountId) && await applyOrCancelDiscountUnpaid({
            parkingId: selectedUnpaid.parkingId,
            carNumber: selectedUnpaid?.parkingEntry.carNum,
            userId: user.userId,
            discountFlag: "CANCEL",
            discountId: item?.discountId,
            entryId: selectedUnpaid?.parkingEntry.parkingEntryId,
            localEntryId: selectedUnpaid?.parkingEntry.localEntryId,
          });

        }

      }
      const response = await applyOrCancelDiscountUnpaid({
        parkingId: selectedUnpaid.parkingId,
        carNumber: selectedUnpaid?.parkingEntry.carNum,
        userId: user.userId,
        discountFlag: type,
        discountId: id,
        entryId: selectedUnpaid?.parkingEntry.parkingEntryId,
        localEntryId: selectedUnpaid?.parkingEntry.localEntryId,
        discountAmount: selectedUnpaid?.fee || 0,
      });

      if (imageArrShow.includes(selectedDiscount)) {
        type == "APPLY" && discountImage && await uploadDiscountImage({
          parkingId: selectedUnpaid.parkingId,
          entryId: selectedUnpaid?.parkingEntry?.localEntryId,
          discountId: selectedDiscount,
          discountApplyId: response?.discountApplyId,
          image: discountImage,
        })
      }

      if (response.status == 200) {
        discountRef.current = (type == "CANCEL" ? null : selectedDiscount)
        setDiscountImage(null);
        setSelectedDiscountRemove("");
        if (type == "CANCEL") {
          setSelectedDiscount("");
          setDiscountImageRemove(null)
        }
        // setSelectedDiscount("");
        let discountDetails = response?.discountDetails.map((item) => ({
          discountId: item.id,
          name: item.name,
          fee: item.fee,
        }));
        dispatch(setSelectedUnpaid({
          ...selectedUnpaid,
          ...response,
          discountDetails: discountDetails,
        }));
        setPaymentAmount(response?.feeFinal);
        // setSelectedDiscount('');
        toast.success('성공했습니다.', {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: 'htToastSuccess',
        });
      } else {
        throw new Error("Failed to apply discount");
      }

      console.log("CheckOut Fee Response:", response);



    } catch (error) {
      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupError', value: true } });
      console.error("Error during discount application:", error);
    } finally {
      dispatch(setAppLoading(false));
    }
  }

  return pageLoading == 1 ? (
    <ParkingSkeleton />
  ) : loadingPayment ? (
    <div className="htContainer htPaymentSuccess">
      <img src={cardIcon} alt="Card" />
      <div className="htPsTile">결제중입니다</div>
      <div className="htPsDesc">나이스페이먼츠 결제 모듈 영역</div>
      <ThreeDots height="60" width="60" color="#4fa94d" ariaLabel="loading" />
    </div>
  ) : completePayment ? (
    <div className="htContainer">
      <SubHeader>
        <div className={`sub-header-text w-full justify-between`}>
          <div className="nl-row">
            <img src={checkIcon} alt="Camera" />
            <span className="ml-5 htBold htColorMain">결제완료</span>
          </div>
          <div>
            <span className="sub-header-btn">출차</span>
          </div>
        </div>
      </SubHeader>

      <div className="htContent htHasButtonBot mn-payment-complete">
        <div className="htSection">
          <h2>차량정보</h2>
          <AppInfoRow label="차량번호" value={selectedUnpaid?.carNumber} />
          <AppInfoRow
            label="입차일시"
            value={datetimeFormat(selectedUnpaid?.inTime, "ISO", "yyyy-MM-dd HH:mm")}
          />
          <AppInfoRow
            label="출차일시"
            value={datetimeFormat(selectedUnpaid?.outTime, "ISO", "yyyy-MM-dd HH:mm")}
          />
          <AppInfoRow
            label="결제요금"
            value={numberFormat(selectedUnpaid?.feeFinal || 0, "원")}
          />
        </div>
        <div className="htSeparator"></div>

        <div className="htSection">
          <h2>결제요금</h2>
          {/* <AppInfoRow label="결제카드" value="현대카드" valueClass="htBold" /> */}
          <AppInfoRow label="결제카드" value={payData?.track2Data} valueClass="htBold" />
          <div className="htInfoRow htBold">
            <span className="">결제금액</span>
            <span className="htTotal">
              {numberFormat(paymentAmount, "원")}
            </span>
          </div>
          <AppInfoRow label="상품명" value="서울특별시 송파구시설관리공단" />
          <AppInfoRow label="승인번호" value="00712341234" />
          <AppInfoRow
            label="거래일시"
            value={getFormattedTime(serverTime, "yyyy-MM-dd HH:mm")}
          />

          {/* <div className="htInfoRow htBold">
            <span className="">결제금액</span>
            <span className="htTotal">
              {numberFormat(selectedUnpaid?.feeFinal, "원")}
            </span>
          </div> */}
        </div>
        <div className="htSeparator" style={{ marginBottom: "30px" }}></div>
        <button className="htSubmitButton" style={{ fontWeight: "400" }} type="button" onClick={() => { onBillPrint(payData) }}>결제내역 재발급</button>

        <ButtonBot
          textYes={`뒤로 가기`}
          handleYes={() => {
            navigate("/parking_unpaid_list");
          }}
        />
        {showPopup && (
          <Popup
            handleYes={() => setShowPopup(false)}
            title="결제 확인"
            textYes="아니오 <br/> (미납처리)"
            textNo="예 <br/>(결제하기)"
            setVisible={setShowPopup}
          >
            <div className="htPpCamera my-3">
              <p>결제를 진행하시겠습니까?</p>
              <p>(결제 미진행 시 미납처리)</p>
            </div>
          </Popup>
        )}
      </div>
    </div>
  ) : (
    isOpenCamera ?
      <div className="htVideoContainer">
        <img
          src={captureClose}
          alt=""
          className="htCaptureClose"
          onClick={() => stopCamera({
            videoRef: videoRef,
            setIsOpenCamera: setIsOpenCamera,
            setShowHeader: (value) => dispatch(setShowHeader(value)),
          })}

        />
        <video ref={videoRef} autoPlay playsInline className="video" >

        </video>
        <div className="htBackground">
          <div className="htChild">
          </div>
          <div className="htChild2">
            <div className="htChild">
            </div>
            <div className="htCornerBorderDiscount">
              <div className="htCornerBorderSubDiscount">

              </div>
              <div className="htCameraControls">
                <button
                  type="button"
                  className="htCaptureButton"
                  onClick={() => captureImage({
                    videoRef: videoRef,
                    canvasRef: canvasRef,
                    setIsOpenCamera: setIsOpenCamera,
                    stopCamera: () => stopCamera({
                      videoRef: videoRef,
                      setIsOpenCamera: setIsOpenCamera,
                      setShowHeader: (value) => dispatch(setShowHeader(value)),
                    }),
                    setImage: setDiscountImage,
                  })}
                >
                  <img src={captureIcon} alt="" />
                </button>
              </div>
            </div>
            <div className="htChild">
            </div>
          </div>

          <div className="htChild">
          </div>
        </div>
        <canvas ref={canvasRef} style={{ display: 'none' }} />
      </div>
      :
      <div className="htContainer">
        <div className="htContent htHasButtonBot">
          <div className="htSection">
            <h2>미납차량 정보</h2>

            <AppInfoRow label="차량번호" value={selectedUnpaid?.carNumber} />
            <AppInfoRow
              label="입차일시"
              value={datetimeFormat(selectedUnpaid?.inTime, "ISO", "yyyy-MM-dd HH:mm")}
            />
            <AppInfoRow
              label="출차일시"
              value={datetimeFormat(selectedUnpaid?.outTime, "ISO", "yyyy-MM-dd HH:mm")}
            />
            <AppInfoRow
              label="결제요금"
              value={numberFormat(selectedUnpaid?.feeFinal, "원")}
            />
          </div>
          <div className="htSeparator"></div>

          <div className="htSection">
            <h2>주차정보</h2>
            <AppInfoRow
              label="요금제"
              value={`${selectedUnpaid?.parkingName} (${selectedUnpaid?.parkingId})`}
            />
            <AppInfoRow
              label="주차시간"
              value={(formatMinutesToTime(selectedUnpaid?.parkingMinute || 0))}
            />
          </div>
          {/* <div className="htSeparator"></div>
          
          <AppSelect
            className="htSection mb-0"
            label="할인적용"
            value={selectedDiscount}
            onChange={({ target }) => {
              const selectedValue = target?.value;

              if (selectedValue === false) return;

              setSelectedDiscount(selectedValue || '');
              discountRef.current = selectedDiscount;
              if (selectedValue) {
                const imageArrShow = ['12', '13', '14', '15', '18', '19', '21', '22', '23', '24', '26', '27', '29', '30'];
                const multipleDiscount = ['10', '30'];
                let currentDiscount = selectedUnpaid?.discountDetails || [];

                if (multipleDiscount.includes(selectedValue) && isIdInArray(currentDiscount, selectedValue)) {
                  return false;
                }
                if (imageArrShow.includes(selectedValue)) {
                  dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupDiscount', value: true } });
                } else {
                  onApplyOrCancelDiscount("APPLY", selectedValue);
                }
              } else {
                onCancelAllDiscount("CANCEL");
              }
            }}
            options={
              discountList.length > 0
                ? discountList
                : [{ label: "할인없음", value: false }]
            }
          /> */}
          <div className="htSeparator"></div>
          <div className="htSection">
            {/* <AppInfoRow label="주차요금" value={""} valueClass="htBold"/>
          <AppInfoRow label="할인요금" value={""} valueClass="htBold"/> */}
            {/* <AppInfoRow label="경차(50%)" value={NumberFormat(-2000, '원')} /> */}
            <h2>결제요금</h2>
            <AppInfoRow label="주차요금" value={numberFormat(selectedUnpaid?.feeCalculated || 0, "원")} valueClass="htBold" />
            {/* {selectedUnpaid?.carType == "FREE" && <AppInfoRow label="경형차" value="무료" valueClass="htBold" />} */}
            {selectedUnpaid?.discountDetails?.length == 0 && selectedUnpaid?.feeDiscount > 0 && (
              <AppInfoRow label="할인요금" value={numberFormat(-Math.abs(selectedUnpaid?.feeDiscount) || 0, "원")} />
            )}
            {
              selectedUnpaid?.discountDetails?.map((item, index) => {
                var imageArrShow = ['12', '13', '14', '15', '18', '19', '21', '22', '23', '24', '26', '27', '29', '30'];
                const isClickable = imageArrShow.includes(String(item.discountId));
                return (
                  <div
                    key={index}
                    className="htInfoRow"
                    onClick={() => {
                      if (isClickable) {
                        setDiscountImageRemove(`${getApiBaseUrl()}facility/uploads?filename=${selectedUnpaid?.parkingEntry?.localEntryId}_discount_id${item.discountId}.jpeg&applyDate=${selectedDiscountApplyTime ? selectedDiscountApplyTime.slice(0, 8) : new Date().toISOString().slice(0, 10).replace(/-/g, '')}&parkingId=${selectedUnpaid?.parkingEntry?.parkingId}&data=${Math.random()}`)
                        setSelectedDiscountRemove(item.discountId);
                        dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscount', value: true } });
                      }
                      // else{
                      //     setSelectedDiscountRemove(item.discountId);
                      //     dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscountNoImage', value: true } });
                      // }  
                    }}>
                    <span className={`htIrLabel nl-row`}>
                      {item.name}
                      {/* <img src={removeDiscountIcon} alt="remove" className="ml-10" /> */}
                    </span>
                    <span className={`htIrValue`}>{item.discountId == '10' ? "-60 분" : numberFormat(-Math.abs(item.fee), "원")}</span>
                  </div>

                )
              })
            }
            <div className="htInfoRow htBold">
              <span className="">결제금액</span>
              <span className="htTotal">
                {numberFormat(selectedUnpaid?.feeFinal, "원")}
              </span>
            </div>
            <div className="htInfoRow">
              <span className=""></span>
              <span style={{ fontSize: "13px" }}>십원 금액 절사</span>
            </div>
          </div>
          {(customImage?.image1 || customImage?.image2) && <div className="htSeparator">
            <div className="htSection">
              <h2>추가사진</h2>
              <div className="nl-row gap-2">
                {customImage?.image1 && <div className="htCarImage htCarImage2"
                  onClick={() => {
                    customImageOrderRef.current = 1;
                    customImage?.image1 ? setIsPopupCustomImageFullOpen(true) : null
                  }}
                  style={customImage?.image1 ? null : { border: '2px dashed #D2D2D2', backgroundColor: "#F8F8F8", overflow: 'hidden' }}
                >
                  <div className="nl-image-license-plate">
                    <img src={customImage?.image1}
                      alt="Uploaded"
                      onError={handleImageError} />
                  </div>
                </div>}
                {customImage?.image2 && <div className="htCarImage htCarImage2"
                  onClick={() => {
                    customImageOrderRef.current = 2;
                    customImage?.image2 ? setIsPopupCustomImageFullOpen(true) : null
                  }} style={customImage?.image2 ? null : { border: '2px dashed #D2D2D2', backgroundColor: "#F8F8F8", overflow: 'hidden' }}
                >
                  <div className="nl-image-license-plate">
                    <img src={customImage?.image2}
                      alt="Uploaded"
                      onError={handleImageError} />
                  </div>
                </div>}
              </div>
            </div>
          </div>}
          <div className="htSeparator"></div>
          <div className="htSection">
            <div className="htSection">
              <h2>결제할 금액</h2>
              <div className="htStMoney mnStMoney">
                <input
                  className="htStMoney mn-input"
                  type="text"
                  placeholder="금액을 입력해주세요"
                  value={
                    paymentAmount || paymentAmount == 0
                      ? numberFormat(paymentAmount)
                      : numberFormat(selectedUnpaid?.feeFinal)
                  }
                  onChange={(e) => {
                    let input = e.target.value;

                    if (input === '') {
                      setPaymentAmount('0');
                    } else {
                      setPaymentAmount(input.replace(/[^0-9]/g, ''));
                    }
                  }}
                />
              </div>
            </div>
          </div>

          <ButtonBot
            textYes={`결제`}
            handleYes={() => {

              if (selectedUnpaid?.parkingMinute >= 0 && selectedUnpaid?.parkingMinute <= 5) {
                dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupFreeFee', value: true } });
                return false;
              } else if (paymentAmount == 0) {
                dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupZeroFee', value: true } });
                return false;
              }
              dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPay', value: true } });
              // if (paymentAmount > 0) {
              //   setShowPopupPay(true);
              // }
            }}
          />
          {isPopupFullCustomImageOpen && (
            <ImageViewPopup
              imageSrc={customImageOrderRef.current == 1 ? customImage.image1 : customImage.image2}
              onClose={() => {
                setIsPopupCustomImageFullOpen(false);
                setZoomLevel(1);
              }}
              zoomLevel={zoomLevel}
              setZoomLevel={setZoomLevel}
              onError={(e) => handleImageError(e)}
            />
          )}
          {popupState.showPopupPay && (
            <Popup
              title="결제 확인"
              handleYes={onPayment}
              textYes="예"
              textNo="아니오"
              setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPay', value: value } })}
            >
              <div className="nl-row f-column">
                <div>결제를 진행하시겠습니까?</div>
              </div>
            </Popup>
          )}
          {popupState.showPopupNice && (
            <Popup
              title="결제"
              handleYes={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupNice', value: false } })}
              textYes="예"
              setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupNice', value: value } })}
            >
              <div className="nl-row f-column">
                <div>NICEPAY 앱을 설치하고 다시 시도해주세요!</div>
              </div>

            </Popup>
          )}
          {popupState.showPopupFeeAlert && (
            <Popup
              title="결제 확인"
              handleYes={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showFeeAlert', value: false } })}
              textYes="예"
              setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showFeeAlert', value: value } })}
            >
              <div className="nl-row f-column">
                <div>
                  최소 {numberFormat(selectedUnpaid?.feeFinal)}원 이상 결제하셔야
                  합니다.
                </div>
              </div>
            </Popup>
          )}
          {popupState.showPopupDiscount && (
            <Popup
              title="할인적용 사진 촬영"
              handleYes={() => onApplyOrCancelDiscount("APPLY", selectedDiscount)}
              textYes="저장하기"
              textNo="취소"
              onClose={() => {
                setDiscountImage(null);
                setSelectedDiscount(discountRef.current || "");
                setShowErrorImg(false);
              }}
              setVisible={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupDiscount', value: false } })}
            >
              <div className="htPpCamera">
                <div className="htPpCamera_tit">{discountList.find(item => item.discountId == selectedDiscount)?.label}</div>
                <div className="htPpCamera__btn" onClick={() => setIsOpenCamera(true)} style={discountImage ? { padding: 0, marginBottom: 15 } : null}>
                  <img src={discountImage ? discountImage : cameraIcon} alt="camera" style={discountImage ? { width: 256, height: 256, objectFit: 'cover' } : null} />
                  {!discountImage && <span className="htBold ml-5">사진 촬영</span>}
                </div>
                <div className={`mt-5 ${showErrorImg ? '' : 'htHide'}`}><span className="htError">사진을 찍어주세요.</span></div>
              </div>

            </Popup>
          )}
          {popupState.showPopupRemoveDiscount && (
            <Popup
              title="할인적용 삭제"
              handleYes={() => onApplyOrCancelDiscount("CANCEL", selectedDiscountRemove)}
              // textYes="예"
              textNo="닫기"
              onClose={() => {
                dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscount', value: false } })
                setDiscountImage(null);
              }}
              handleNo={() => {
                dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscount', value: false } })
                setDiscountImage(null);
              }} setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscount', value: value } })}
            >
              <div className="nl-row f-column">
                {/* <div>정말로 이 할인 코드를 삭제하시겠습니까?</div> */}
                {discountImageRemove && <div className="htPpCamera__btn nl-row j-center mt-10">
                  <img src={discountImageRemove ? discountImageRemove : cameraIcon} onError={(e) => handleImageError(e)} alt="camera" style={discountImageRemove ? { width: 256, height: 256, objectFit: 'cover' } : null} />
                  {!discountImageRemove && <span className="htBold ml-5">사진 촬영</span>}
                </div>}
              </div>

            </Popup>
          )}
          {popupState.showPopupRemoveDiscountNoImage && (
            <Popup
              title="할인적용 삭제"
              handleYes={() => onApplyOrCancelDiscount("CANCEL", selectedDiscountRemove)}
              textYes="예"
              textNo="아니오"
              onClose={() => {
                dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscountNoImage', value: false } })
                setDiscountImage(null);
              }}
              handleNo={() => {
                dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscountNoImage', value: false } })
                setDiscountImage(null);
              }}
              setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscountNoImage', value: value } })}
            >
              <div className="nl-row f-column">
                <div>정말로 이 할인 코드를 삭제하시겠습니까?</div>
              </div>

            </Popup>
          )}
          {popupState.showPopupPayError && (
            <Popup
              title="결제"
              handleYes={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPayError', value: false } })}
              textYes="예"
              setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPayError', value: value } })}
            >
              <div className="nl-row f-column">
                <div>결제 중 오류가 발생했습니다. 다시 시도해주세요!</div>
              </div>


            </Popup>
          )}
          {popupState.showPopupMissingTid && (
            <Popup
              title="결제"
              handleYes={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupMissingTid', value: false } })}
              textYes="예"
              setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupMissingTid', value: value } })}
            >
              <div className="nl-row f-column">
                <div>주차장에 대한 결제 식별자(TID) 정보가 없습니다.</div>
              </div>


            </Popup>
          )}

          {popupState.showPopupFreeFee && (
            <Popup
              title="알림"
              handleYes={() => onFreeFee()}
              textYes="예"
              textNo="아니오"
              handleNo={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupFreeFee', value: false } })}
              setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupFreeFee', value: value } })}
            >
              <div className="nl-row f-column">
                <div>회차 차량의 출차를 진행할까요?</div>
              </div>

            </Popup>
          )}
          {popupState.showPopupZeroFee && (
            <Popup
              title="알림"
              handleYes={() => onFreeFee()}
              textYes="예"
              textNo="아니오"
              handleNo={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupZeroFee', value: false } })}
              setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupZeroFee', value: value } })}
            >
              <div className="nl-row f-column">
                <div>이 차량의 출차를 진행할까요?</div>
              </div>

            </Popup>
          )}
        </div>
      </div>
  );
}

export default ParkingUnpaidDetail;


function ParkingSkeleton() {
  return (
    <div className="htSection" style={{ padding: '16px' }}>
      <h2>입차정보</h2>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={80} height={20} /></div>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={120} height={20} /></div>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={140} height={20} /></div>

      <h2 style={{ marginTop: 24 }}>주차정보</h2>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={140} height={20} /></div>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={140} height={20} /></div>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={60} height={20} /></div>
      <h2 style={{ marginTop: 24 }}>할인적용</h2>
      <div><Skeleton height={40} width="100%" /></div>
      {/* <div><Skeleton width={100} height={20}/></div> */}

      <h2 style={{ marginTop: 24 }}>결제금액</h2>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={140} height={20} /></div>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={140} height={20} /></div>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={60} height={20} /></div>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={60} height={20} /></div>

      <h2 style={{ marginTop: 24 }}>결제할 금액</h2>
      <div><Skeleton width="100%" height={40} /></div>
    </div>
  );
}